import $ from 'jquery';
import '../scss/style.scss';
import * as bootstrap from 'bootstrap';
import './hyphenation.mjs';
import './modernizr.mjs';
import './carousel.mjs';
import './accordion.mjs';
import './masonry.mjs';
import './finna.mjs';
import Headroom from 'headroom.js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import './react/articleListing/articleListApp.jsx';
import './react/contactSearch/ContactSearchApp.jsx';
import './react/eventListing/eventListApp.jsx';
import './react/projectListing/ProjectListApp.jsx';
import './react/react.jsx';
import 'focus-visible';
import './search.mjs';
import './image-underline-hack.mjs';
import lozad from 'lozad';
import {main} from "@popperjs/core";
import {wrapMapToPropsConstant} from "react-redux/es/connect/wrapMapToProps.js";

window.bootstrap = bootstrap;

const observer = lozad();
observer.observe();

export function AnimatePlusMinus(item, wrapper) {
    let iconClass = 'menu--open';
    $(item).toggleClass(iconClass);
    if (wrapper) {
        $(wrapper)
            .find('.laurea-icon')
            .not(item)
            .removeClass(iconClass);
    }
}


$(document).ready(function() {
    let $imagePopUp,
        $heroHeight = $('main section:first-of-type').outerHeight() + 100,
        headerDesktop = $('header.desktop')[0],
        headerMobile = $('header.mobile')[0],
        bodyElement = $('body'),
        stickyHeight = $('nav.sticky').outerHeight() + 25
    
    const navBarCollection = [];
    const navBarSelected = new Set();
    const idParentPositionMap = new Map()

    // Select auto if browser support different scroll-behavior.
    $("html").css('scroll-behavior', 'auto');
    

    // construct an instance of Headroom, passing the element
    window.headroom = new Headroom(headerDesktop, {
        offset: 100,
        onPin: function () {
            bodyElement.addClass('is--pinned');
        },
        onUnpin: function () {
            bodyElement.removeClass('is--pinned');
        },

        onTop: function () {
            bodyElement.removeClass('is--pinned');
        },
    });

    window.headroomMobile = new Headroom(headerMobile, {
        offset: 200,
        onPin: function () {
            bodyElement.addClass('is--pinned');
        },
        onUnpin: function () {
            bodyElement.removeClass('is--pinned');
        },

        onTop: function () {
            bodyElement.removeClass('is--pinned');
        },
    });

    // initialise
    headroom.init();
    headroomMobile.init();

    const spyNavBarSticky = $("#navbar-sticky");
    const lastSectionInMain = $("#main").find(":last-child").find("div").filter(function () {
        return $(this).attr("id");
    });

    spyNavBarSticky.children().each((index, element) => {
        navBarCollection.push(element.hash.replace("#", ""));
    })

    for (let index = 0; index <= navBarCollection.length - 1; index++) {
        const start = $(`#${navBarCollection[index]}`);
        const startPosition = start.offset().top;        
        const endPosition = (navBarCollection.length - 1 >= index + 1)
            ? $(`#${navBarCollection[index + 1]}`).offset().top
            : start.offset().top + start[0].scrollHeight

        idParentPositionMap.set(navBarCollection[index], {
            start: startPosition,
            end: endPosition
        })
    }

    // This handling now scrollpy effect for episerver website.
    $(window).on('scroll', function (event) {

        if ($(window).scrollTop() < $heroHeight) {
            $('body').removeClass('is--pinned');
        }

        if ($(window).scrollTop() === 0) {

            $("#navbar-sticky").find("a.active").removeClass("active")
        }
        
        let scrollPosition = $(document).scrollTop();
        idParentPositionMap.forEach((position, id) => {
            const spyElement = $(`#${id}`);
            const rootSpyElement = spyElement.parent().parent();
            if ((position.end > scrollPosition  && position.start - 90 < scrollPosition) || detectScrollEnd() ) {
                if (!navBarSelected.has(id)) {
                    if (navBarSelected.size > 0) {
                        navBarSelected.forEach((selectedId) => {
                            const spy = spyNavBarSticky.find(`[href="#${selectedId}"]`);
                            spy.removeClass("active");
                            navBarSelected.clear();
                        })
                    }
                }

                navBarSelected.add(id);
                const spy = spyNavBarSticky.find(`[href="#${id}"]`);
                spy.addClass("active");
            }
        })
    });

    let headroomTimeout;
    
    $('nav.sticky a').on('click', function (event) {
        let anchor = $(this).attr('href');
        clearTimeout(headroomTimeout);
        
        $('body').removeClass('is--pinned');
        $('header.desktop, header.mobile').addClass('js-hide-headroom');
        
        window.headroom.tolerance.up = 100000;
        
        $('html, body').animate(
            {
                scrollTop: `${$(anchor).position().top - stickyHeight}px`,
            },
            200,
            function () {
                headroomTimeout = setTimeout(function () {
                    window.headroom.tolerance.up = 0;
                }, 3000);
            }
        );


    });

    $('nav.sticky a[href^="#"]').on('click', function (e) {
        let hash = this.hash;
        window.location.hash = hash;
        e.preventDefault();
    });

    // Create arrow to FormSubmitButton.
    $(".FormSubmitButton").append("<i class=\"la icon-la-arrow-right\"></i>")

    $('.contact-card__photo').each(function () {
        var $el = $(this);

        if (!$el.children('div').length > 0) {
            // $(this).append('<div class="contact-card__img-wrapper rounded-circle bg--none"></div>');
        } else {
        }
    });

    var areClipPathShapesSupported = function () {
        var base = 'clipPath',
            prefixes = ['webkit', 'moz', 'ms', 'o'],
            properties = [base],
            testElement = document.createElement('testelement'),
            attribute = 'polygon(50% 0%, 0% 100%, 100% 100%)';

        // Push the prefixed properties into the array of properties.
        for (var i = 0, l = prefixes.length; i < l; i++) {
            var prefixedProperty =
                prefixes[i] + base.charAt(0).toUpperCase() + base.slice(1); // remember to capitalize!
            properties.push(prefixedProperty);
        }

        // Interate over the properties and see if they pass two tests.
        for (var i = 0, l = properties.length; i < l; i++) {
            var property = properties[i];

            // First, they need to even support clip-path (IE <= 11 does not)...
            if (testElement.style[property] === '') {
                // Second, we need to see what happens when we try to create a CSS shape...
                testElement.style[property] = attribute;
                if (testElement.style[property] !== '') {
                    // console.log('CLIPPATH!');
                    return true;
                }
            }
        }
        // console.log('NO CLIPPATH!');
        return false;
    };

    if (!areClipPathShapesSupported()) {
        $('body').addClass('triangle-skew');
    }

    function closeSubMenu() {
        $openSubMenuIcon.removeClass('menu--open');
        $openSubMenuItem.hide();
    }

    $('.menu-toggler').on('click', function (event) {
        event.preventDefault();
        $('.navigation-menu').toggleClass('in');
        $('body').toggleClass('has-overlay--open');

        if ($('body').hasClass('has-overlay--open')) {
            // console.log('***enable!');
            disableBodyScroll($('.js-menu-overlay-inner')[0]);
            $('html').attr('style', '');
        } else {
            // console.log('***disable!');
            enableBodyScroll($('.js-menu-overlay-inner')[0]);
            // console.log('enable?');
            $('html').attr('style', '');
        }
    });

    $('.site-search-toggler').on('click', function (event) {
        event.preventDefault();
        $('.site-search-layer').toggleClass('in');
        $('body').toggleClass('has-overlay--open');
        $('#input-site-search').focus();
    });

    $('.navigation-menu__main .laurea-icon.anim-plus-minus').on(
        'click',
        function (event) {
            event.preventDefault();
            let $icon = $(this);
            let $subMenu = $(this)
                .closest('li.nav-item')
                .find('.navigation__sub-menu');
            $('li.nav-item')
                .find('.navigation__sub-menu')
                .not($subMenu)
                .slideUp(200);
            AnimatePlusMinus($icon, $('.navigation-menu__main'));
            $subMenu.slideToggle(200);
        }
    );

    $('.nav-anchors--secondary a').on('click', function (event) {
        event.preventDefault();
        $('.nav-anchors--secondary a')
            .not($(this))
            .removeClass('active');
        $(this).addClass('active');
    });

    // img popup

    $('.no-touchevents .article__image img').on('click', function (event) {
        let $url = $(this).attr('src');
        zoomImage($url);
    });

    $(document).on('click', '.overlay__image', function () {
        removeImagePopUp();
    });
    
    const triggerTabList = document.querySelectorAll('#libraryTabs a')
    
    triggerTabList.forEach(triggerEl => {
        const tabTrigger = new bootstrap.Tab(triggerEl);
        
        triggerEl.addEventListener('click', event => {
            event.preventDefault();
            tabTrigger.show();
        })
    });

    const courseTabList = document.querySelectorAll(".courses__buttons a")
    courseTabList.forEach(triggerEl => {
        const tabTrigger = new bootstrap.Tab(triggerEl);
        triggerEl.addEventListener('click', event => {
            event.preventDefault();
            tabTrigger.show();
        })
    })

    function detectScrollEnd() {
        return ($(window).scrollTop() + $(window).height()) >= $(document).height();
    }
    function zoomImage(src) {
        $('body').addClass('has-overlay--open');
        $imagePopUp = $('body').append(
            '<div class="overlay overlay__image overlay--dynamic"><img class="overlay__image--item" src="' +
            src +
            '"><a href="javascript:void(0)" class="close"><i class="fa fa-times"></i></a></a></div>'
        );
    }

    function removeImagePopUp() {
        $('body').removeClass('has-overlay--open');
        $('.overlay__image')
            .hide(100)
            .remove();
    }
});
